import { IconButton } from "@mui/material";
import WhatsappIcon from "@/assets/icons/lead-page/whatsapp-icon";
import { handleContactWhatsapp } from "@/modules/common/utils";

const ContactWhatsappIcon = ({ phoneNumber }: { phoneNumber?: string }) => {
  return (
    <IconButton
      sx={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: "#25d366",
        padding: "8px",
        "&:hover": { backgroundColor: "#1da851" },
      }}
      onClick={() => handleContactWhatsapp(phoneNumber)}
    >
      <WhatsappIcon fill="white" />
    </IconButton>
  );
};

export default ContactWhatsappIcon;
